var map = {
	"./arrow-right.svg": "dxdv",
	"./back-top.svg": "B6fW",
	"./circle.svg": "5gjf",
	"./cube.svg": "twYg",
	"./eye.svg": "4wdf",
	"./muted.svg": "nARH",
	"./pie.svg": "+hJ1",
	"./play-triangle.svg": "ETQg",
	"./play.svg": "ufmG",
	"./position.svg": "3sTt",
	"./user.svg": "VdD3"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 9